import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-card-vendor-page-ui',
    templateUrl: './bb-card-vendor-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CardVendorPageComponent {}
